import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
// import { setDataOnCookie } from '../../Functionalities/Functions'
import { ManageManagers, ManageSingleManagers } from "./Logic";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { showMessage } from "../../Functionalities/Functions";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import { validateEmail } from '../../Functionalities/Validation'

function Body(props) {
  let id = props.id;
  const [loading, setloading] = useState(true)
  const [noData, setnoData] = useState(false)
  const [edit, setEdit] = useState(false)
  const [editData, setEditData] = useState({
    manager_id: "",
    is_blocked: "",
  });
  const [passwords, setPasswords] = useState({
    pass: '',
    cpass: ''
  })
  const [userNameChanged, setUserNameChanged] = useState(false)
  const [data, setData] = useState({});
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = () => {
    let result = ManageSingleManagers("", "", "get", `keyword=all_profile&user_id=${id}`);
    result.then((result) => {
      if (result.data.results.length > 0) {
        setData(result.data.results[0]);
        setEditData({
          ...editData,
          is_blocked: result.data.results[0].details.is_blocked,
          manager_id: result.data.results[0].id,
        });
        setloading(false)
      }
      else {
        setnoData(true)
        setloading(false)
      }

    });
  };

  return (
    <div class="content-body">
      <div class="container-fluid">
        {!loading ?
          (!noData ?
            <>
              <div class="page-titles">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0)">Manager</a>
                  </li>
                  <li class="breadcrumb-item active">
                    <a href="javascript:void(0)">Manager</a>
                  </li>
                </ol>
              </div>
              <div className="col-xl-12 col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Manager</h4>
                    <span>
                      {!edit &&
                        <button
                          type="submit"
                          onClick={(e) => {
                            e.preventDefault();
                            setEdit(true)
                          }}
                          className="btn btn-primary mr-1"
                        >
                          Edit
                 </button>}
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          confirmAlert({
                            customUI: ({ onClose }) => {
                              return (
                                <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5 }}>
                                  <h1>Are you sure?</h1>
                                  <p>You want to delete ?</p>
                                  <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
                                  <button

                                    onClick={() => {
                                      let result = ManageManagers(e, editData, "patch");
                                      result.then((result) => {
                                        if (result) {
                                          //alert("success");
                                          showMessage("Delete success", "success", "Success!", "top", "top-right")

                                          window.location.replace('/managers')
                                        } else {
                                          showMessage("delete failed", "danger", "Failed!", "top", "top-right")
                                        }
                                      }).catch(err => {
                                        showMessage("delete failed", "danger", "Error!", "top", "top-right")

                                      })
                                    }}
                                    className="btn btn-primary"
                                  >
                                    Delete
                                   </button>
                                </div>
                              );
                            }
                          });
                        }}
                        className="btn btn-primary mr-1"
                      >
                        Delete
                 </button>
                    </span>
                  </div>

                  <div className="card-body">
                    <div className="basic-form">
                      <form>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Manager name
                       </label>
                          <div className="col-sm-9">
                            <input type="text" className="form-control" disabled={!edit} onChange={e=> setData({...data, first_name: e.target.value})} value={data.first_name} />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Username
                       </label>
                          <div className="col-sm-9">
                            <input type="text" className="form-control" disabled={!edit} onChange={e=> {setUserNameChanged(true); setData({...data, username: e.target.value})}} value={data.username} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Password
                       </label>
                          <div className="col-sm-9">
                            <input type="text" className="form-control" disabled={!edit} onChange={e=> setPasswords({...passwords, pass: e.target.value})} value={data.pass} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Confirm Password
                       </label>
                          <div className="col-sm-9">
                            <input type="text" className="form-control" disabled={!edit} onChange={e=> setPasswords({...passwords, cpass: e.target.value})} value={data.cpass} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Email 
                          {/* <span className="required">*</span> */}
                          </label>
                          <div className="col-sm-9">
                            <input type="text" className="form-control" disabled={!edit} onChange={e=> setData({...data, email: e.target.value})} value={data.email} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Mobile <span className="required">*</span></label>
                          <div className="col-sm-9">
                            <input type="number" className="form-control" disabled={!edit} onChange={e=> setData({...data, details: {...data.details, mobile: e.target.value.slice(0, 10)}})} value={data.details && data.details.mobile}
                               onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-' || evt.key === '.') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                               onWheelCapture={e => {e.target.blur()}}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Block/Recover</label>
                          <div className="col-sm-2 ">
                            <div className="custom-control custom-checkbox mb-3">
                              <input
                                type="checkbox"
                                disabled={!edit}
                                checked={editData.is_blocked}
                                onChange={(e) => {

                                  setEditData({
                                    ...editData,
                                    is_blocked: e.target.checked,
                                  });
                                }}
                                className="custom-control-input"
                                id="customCheckBox1"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="customCheckBox1"
                              ></label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-sm-9">
                            {edit && <><button
                              type="submit"
                              className="btn btn-primary mr-2"
                              onClick={(e) => {
                                e.preventDefault();
                                var dataToSend = {...data, is_blocked: editData.is_blocked, password: passwords.pass, userNameChanged: userNameChanged}
                                if(passwords.pass){
                                  if(passwords.pass != passwords.cpass){
                                    showMessage("Passwords should match", "danger", "failed", 'top', "top-right", 0)
                                    return
                                  }
                                  if(passwords.pass.length < 4){
                                    showMessage("Password should be greater than 3 letters", "danger", "failed", 'top', "top-right", 0)
                                    return
                                  }
                                }
                                if (data.details.mobile === "") {
                                  // setdisable(false)
                                  showMessage("Mobile required", "danger", "Error!", "top", "top-right", 0)
                                  return
                              }
                                if(data.details.mobile.length < 10){
                                  showMessage("Mobile number should be 10", "danger", "failed", 'top', "top-right", 0)
                                  return
                                }

                                // if (data.email === "") {
                                //   // setdisable(false)
                                //   showMessage("Email required", "danger", "Error!", "top", "top-right", 0)
                                //   return
                                // }
                                // if (validateEmail(data.email) === false) {
                                //     // setdisable(false)
                                //     showMessage("Please enter a valid email", "danger", "Error!", "top", "top-right", 0)
                                //     return
                                // }
                                // return
                                
                                let result = ManageManagers(e,dataToSend,"update_full","");
                                result.then((result) => {
                                  
                                  if(result){
                                    if(result.data.Status){
                                setEdit(false)

                                      showMessage("details updated", "success", "Success!", "top", "top-right", 0)
                                    }else{
                                      showMessage("details update failed", "danger", "Failed!", "top", "top-right", 0)
                                setEdit(false)

                                    }
                                  }
                                 
                                }).catch(err=> {
                                setEdit(false)

                                  showMessage("details update failed", "danger", "Failed!", "top", "top-right", 0)
                                })
                              }}
                            >
                              Save
                         </button>
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setEdit(false)
                                }}
                              >
                                Cancel
                       </button>
                            </>}
                          </div>
                        </div>
                      </form>
                    </div>

                  </div>
                </div>
              </div>

            </>

            : <NoDataComponent data="Manager " />)
          : <LoadingComponent />}

      </div>
    </div>
  );
}

function Manager() {
  let { id } = useParams();
  // void 0
  // let data1=JSON.parse(data)
  const headers = "Manager";

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />{" "}
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body id={id} />
        <Footer />
      </div>
    </div>
  );
}

export default Manager;
